import { inject, Injectable, Injector } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';
import { WellSystemSettingsStore } from '../well-system-settings.store';

@Injectable({ providedIn: 'root' })
export class WellSystemSettingsFacade {
  private store = inject(WellSystemSettingsStore);
  private injector = inject(Injector);

  // Signal API (new)
  readonly currencyList = this.store.currencyList;
  readonly numberOfDaysForCalendarOffset = this.store.numberOfDaysForCalendarOffset;

  // Observable API (backward compatible)
  readonly currencyList$ = toObservable(this.store.currencyList);

  getSetting<T = unknown>(key: string): Observable<T | undefined> {
    return toObservable(this.store.getSettingSignal<T>(key), { injector: this.injector });
  }

  getCurrencyList(): Observable<{ label: string; value: string }[]> {
    return this.currencyList$;
  }

  updateSetting(key: string, value: unknown): void {
    this.store.updateSetting(key, value);
  }

  updateNumberOfDaysForCalendarOffset(value: number): void {
    this.store.updateNumberOfDaysForCalendarOffset(value);
  }
}
